export default __webpack_public_path__ + "e614c7c58526b959fd7eeef87ee17a19.png";